<template>
  <div class="flex justify-center md:max-w-2xl w-full bg-white rounded-lg">
    <EditDraftInfo
      v-if="this.showInfo === true"
      @exit="this.exit()"
      @next="(this.showInfo = false), (this.showAspects = true)"
      @draft="draftCreated"
    />
    <EditDraftAspects
      v-if="this.showAspects === true"
      @back="(this.showAspects = false), (this.showInfo = true)"
      @exit="this.exit()"
      @next="(this.showAspects = false), (this.showRatings = true)"
      @draft="draftCreated"
    />
    <EditDraftRatings
      v-if="this.showRatings === true"
      @back="(this.showRatings = false), (this.showAspects = true)"
      @exit="this.exit()"
      @next="(this.showRatings = false), (this.showPreview = true)"
      @draft="draftCreated"
    />
    <EditDraftPreview
      v-if="this.showPreview === true"
      :isNewSlydePost="true"
      @back="(this.showPreview = false), (this.showRatings = true)"
      @exit="this.exit()"
      @next="closeModal"
      @draft="draftCreated"
    />
  </div>
</template>

<script>
import EditDraftInfo from './EditDraftInfo.vue';
import EditDraftAspects from './EditDraftAspects.vue';
import EditDraftRatings from './EditDraftRatings.vue';
import EditDraftPreview from './EditDraftPreview.vue';
import store from '@/store/store';
import router from '@/router/index';

export default {
  name: 'EditDraft',
  data() {
    return {
      showInfo: true,
      showAspects: false,
      showRatings: false,
      showPreview: false,
    };
  },
  props: [],
  components: {
    EditDraftInfo,
    EditDraftAspects,
    EditDraftRatings,
    EditDraftPreview,
  },
  methods: {
    closeModal() {
      this.$emit('slydepostCreated');
      this.showInfo = false;
      this.showAspects = false;
      this.showRatings = false;
      this.showPreview = false;
      store.state.newSlydepost = {};
      router.push('/');
    },
    exit() {
      router.push('/');
    },
    draftCreated() {
      this.$emit('slydepostCreated');
      this.showInfo = false;
      this.showAspects = false;
      this.showRatings = false;
      this.showPreview = false;
      store.state.newSlydepost = {};
      router.push({ name: 'Drafts' });
    },
  },
  mounted() {
    this.showInfo = true;
    this.showAspects = false;
    this.showRatings = false;
    this.showPreview = false;
  },
  unmounted() {
    this.$store.commit('editPostDraftStoreModule/clear');
  },
};
</script>
